import React, { FunctionComponent } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import gray from '@material-ui/core/colors/grey';
type InspectionDetailNodeProps = {
    label: string;
    value: any;
};
const InspectionDetailNode: FunctionComponent<InspectionDetailNodeProps> = (props) => {
    const classes = makeStyles(() => ({
        detailNode: {
            textAlign: 'left',
            marginTop: 25,
        },
        detailNodeLabel: {
            fontSize: 16,
            fontWeight: 600,
            color: gray[700],
        },
        detailNodeValue: {
            marginTop: 8,
            fontSize: 14,
            fontWeight: 450,
            color: gray[600],
        },
        detailNodeIcon: {
            marginLeft: 8,
        },
    }))();
    return (
        <Box className={classes.detailNode}>
            <Box className={classes.detailNodeLabel}>{props.label}</Box>
            <Box display="flex" className={classes.detailNodeValue}>
                {props.value}
            </Box>
        </Box>
    );
};

export default InspectionDetailNode;
